import { useEffect, useRef, useCallback } from 'react';

export function useSSENotifications(onUpdate) {
  const esRef = useRef(null);
  const reconnectTimer = useRef(null);
  const mountedRef = useRef(true);

  const connect = useCallback(() => {
    if (!mountedRef.current) return;

    // Cookie-based auth: withCredentials sends the httpOnly cookie automatically.
    // Falls back gracefully for API clients still using Authorization header.
    const es = new EventSource('/api/notifications/stream', { withCredentials: true });
    esRef.current = es;

    es.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.type === 'heartbeat') return; // keep-alive — ignorar
        if (data.type === 'notifications') {
          onUpdate({ items: data.items, total_unread: data.total_unread });
        }
      } catch {
        // mensagem malformada — ignorar
      }
    };

    es.onerror = () => {
      es.close();
      esRef.current = null;
      if (mountedRef.current) {
        reconnectTimer.current = setTimeout(connect, 5000);
      }
    };
  }, [onUpdate]);

  useEffect(() => {
    mountedRef.current = true;
    connect();

    return () => {
      mountedRef.current = false;
      clearTimeout(reconnectTimer.current);
      esRef.current?.close();
    };
  }, [connect]);
}
